import { useEffect, useState, useRef } from "react";
import * as Components from "../";
import { CloseOutlined } from "@ant-design/icons";
import { Modal, Button, Popconfirm } from "antd";
import { ReceiptType, PaperSize } from "../../utils/enums";
import { owntoast } from "../../utils";
import { SaleBill } from "../SaleBill";
import { useReactToPrint } from "react-to-print";
import dayjs from "dayjs";

function SaleDetailModal(props) {
  const {
    isOpen,
    setIsOpen,
    data,
    request,
    onSubmit,
    page,
    _auth,
    rescheckService,
    columns,
    isReturn,
    modalUrl,
    modalHeader,
    modalMethod,
    modalIdKey,
    dataIndex,
    modalTitles,
  } = props;
  const orderRef = useRef();
  const [loading, setLoading] = useState(false);
  const [receiptData, setReceiptData] = useState(null);

  useEffect(() => {
    if (isOpen && data && modalMethod && modalUrl && modalIdKey) {
      let body = {};
      if (modalMethod === "POST") {
        let tmp = JSON.parse(localStorage.getItem(`search${props.page.url}`));
        if (tmp) body = { ...tmp };
      }
      request({
        url: `${modalUrl}/${data[modalIdKey]}`,
        model: `${dataIndex}detail`,
        method: modalMethod,
        body,
      });
    }
  }, [isOpen]);

  const handleReturn = () => {
    if (data) {
      if (data.type !== 1) {
        owntoast(
          "Буцаалт хийсэн борлуулалтыг дахин буцаах боломжгүй.",
          "error"
        );
      } else {
        setLoading(true);
        request({
          url: `/sale/payreturn/${data.id}`,
          method: "POST",
        }).then((res) => {
          setLoading(false);
          if (res.success) {
            setReceiptData({
              ...res.data,
              isReturn: true,
              isReprint: false,
              type: ReceiptType.Борлуулалт,
            });
            let searchValues = JSON.parse(
              localStorage.getItem(`search${page.url}`)
            );
            onSubmit(searchValues);
            setIsOpen(false);
            print({ ...res.data, isReturn: true, isReprint: false });
            owntoast(res.message, "success");
          } else {
            owntoast(res.message, "error");
          }
        });
      }
    } else {
      owntoast("Борлуулалтын мэдээлэл олдсонгүй.", "error");
    }
  };

  const print = (data) => {
    if (data) {
      let body = {
        ...data,
        vatname: _auth.vatname,
        regno: _auth.regno,
        username: _auth.username,
      };
      if (rescheckService === true) {
        request({
          url: `/print/${PaperSize.m58}`,
          body: body,
          method: "POST",
          isservice: true,
        });
      } else {
        printOrder();
      }
    }
  };

  const printOrder = useReactToPrint({
    content: () => orderRef.current,
  });

  const handleReprint = () => {
    if (data) {
      request({ url: `/sale/reprint/${data.id}` }).then((res) => {
        if (res.success) {
          setReceiptData({
            ...res.data,
            isReturn: false,
            isReprint: true,
            type: ReceiptType.Борлуулалт,
          });
          owntoast(res.message, "success");
          print({ ...res.data, isReturn: false, isReprint: true });
        } else {
          owntoast(res.message, "error");
        }
      });
    }
  };
  const renderTitles = () => {
    let tmp = JSON.parse(localStorage.getItem(`search${props.page.url}`));
    if (data && modalTitles && tmp) {
      return modalTitles.map((item, i) => (
        <div className="flex mb-2">
          <span>{`${item.label} : `}</span>
          <span className="ml-1">
            {item.valueprop.includes("sdate,edate")
              ? `${dayjs(tmp.sdate).format("YYYY-MM-DD")} - ${dayjs(
                  tmp.edate
                ).format("YYYY-MM-DD")}`
              : data[item.valueprop]}
          </span>
        </div>
      ));
    }
  };

  return (
    <Components.GlobalModal
      footer={null}
      width={800}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title={modalHeader ? modalHeader : `Баримтын дэлгэрэнгүй`}
    >
      {renderTitles()}
      <Components.AntdTable
        dataSource={
          props[`res${dataIndex}detail`] ? props[`res${dataIndex}detail`] : []
        }
        loading={props[`is${dataIndex}detail`] ? true : false}
        columns={columns}
        pagination={false}
        isModal={true}
      />
      <div className="flex gap-2 justify-between mt-2 p-4">
        {isReturn ? (
          <div className="flex gap-2">
            <Popconfirm
              title="Та уг борлуулалтыг буцаалт хийхдээ итгэлтэй байна уу ?"
              onConfirm={handleReturn}
              okText="Тийм"
              cancelText="Үгүй"
            >
              <Button type="primary" loading={loading}>
                Буцаалт хийх
              </Button>
            </Popconfirm>

            <Button
              className="bg-buttonBlue text-white"
              onClick={handleReprint}
            >
              Дахин хэвлэх
            </Button>
          </div>
        ) : (
          <div />
        )}

        <Button className="bg-grey text-white" onClick={() => setIsOpen(false)}>
          Хаах
        </Button>
      </div>
      {isReturn ? (
        <div className="hidden">
          <SaleBill ref={orderRef} data={receiptData} />
        </div>
      ) : null}
    </Components.GlobalModal>
  );
}

export default SaleDetailModal;
